import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	ownedBy: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noOwner: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	ownedBy: {
		id: 'project-directories.components.compass-table.cells.dependencies.popup-content.dependency-row.owner-new',
		defaultMessage: '{componentName} <text>owned by</text> {teamName}',
		description:
			'Text displaying who owns a component. Message will show like: "{componentName} owned by {teamName}".',
	},
	noOwner: {
		id: 'project-directories.components.compass-table.cells.dependencies.popup-content.dependency-row.no-owner-new',
		defaultMessage: '{componentName} <text>No owner</text>',
		description: 'Highlights that a component with name componentName has no owner.',
	},
});
export default messages;
